import { Component, Input, OnInit } from '@angular/core';
import ProjectInvoice from 'src/app/model/invoice/project-invoice';
import { BoardTypeChoices } from 'src/app/model/product/board/board-part';
import ipBoard from 'src/app/model/product/ip-board/ip-board';
import ipBoardPart from 'src/app/model/product/ip-board/ip-board-part';
import Product from 'src/app/model/product/product';
import { SoldRented } from 'src/app/model/project/sold-rented';

@Component({
  selector: 'sticker-facturation',
  templateUrl: './sticker-facturation.component.html',
  styleUrls: [
    './sticker-facturation.component.scss',
    '../../../..//pages/client-corner/client-project-detail/client-pending-detail/detail-card/facturation-card/facturation-card.component.scss'
  ]
})
export class StickerFacturationComponent implements OnInit {
  @Input()
  projectId: number;

  @Input()
  subProject: SoldRented;

  @Input()
  product: Product;

  @Input()
  secondBoardPresent: boolean = false;

  @Input()
  invoice: ProjectInvoice;

  @Input()
  displayCompanyName: boolean = true;

  @Input()
  numInvolvedCompanies: number = 1;

  charge: number = 1;

  constructor() {}

  ngOnInit(): void {
    const ipBoard = this.product as ipBoard;
    const ipBoardPart = ipBoard.boardPart as ipBoardPart;
    const chargeTwice =
      ipBoardPart.boardType != null &&
      (ipBoardPart.boardType.ordinal === BoardTypeChoices.V.ordinal ||
        ipBoardPart.boardType.ordinal ===
          BoardTypeChoices.DOUBLE_SIDED.ordinal) &&
      !ipBoard.leftRightBoard;
    this.charge = chargeTwice ? 2 : 1;
  }
}
